import { render, staticRenderFns } from "./PictureBookDisplay.vue?vue&type=template&id=2b599262&"
import script from "./PictureBookDisplay.vue?vue&type=script&lang=js&"
export * from "./PictureBookDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports